import type { TopMarketOutcomeType } from '../../../@types';
import {
  getSortedFeaturedEventItems,
  toPublishedEventListItem,
  type GroupedFeaturedEventGroup,
} from '../../../hooks/useGroupedFeaturedContent';
import useLocalization from '../../../hooks/useLocalization';
import Heading from '../../atoms/Heading';
import Carousel from '../../organisms/Carousel';
import EventCard from '../EventCard';

type GroupedFeaturedEventsCarouselBaseProps = {
  title: string;
  outcomeTypes?: TopMarketOutcomeType[];
  link?: string;
};

export type GroupedFeaturedEventsCarouselProps = GroupedFeaturedEventsCarouselBaseProps & {
  groups: GroupedFeaturedEventGroup[];
};

const GroupedFeaturedEventsCarousel = ({ title, groups, link }: GroupedFeaturedEventsCarouselProps) => {
  const { t } = useLocalization();
  const items = getSortedFeaturedEventItems(groups);

  if (!items.length) {
    return null;
  }

  return (
    <>
      <Heading to={link}>
        <Heading.Title>{title}</Heading.Title>
        {link && <Heading.Link>{t('goToMatches')}</Heading.Link>}
      </Heading>
      <Carousel>
        {items.map(({ group, event }) => (
          <EventCard
            key={event.id}
            event={toPublishedEventListItem(group, event)}
            topMarketTypes={group.topMarketTypes}
          />
        ))}
      </Carousel>
    </>
  );
};

export default GroupedFeaturedEventsCarousel;
